import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Input, Select, Typography, Space, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { TrainingProjectsStore } from '../../stores';
import { trainingProjectFormFields } from '../../misc/constants';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectModelsSettings: React.FC<Props> = ({ store }) => {
    return (
        <>
            <Typography.Title level={5}>Model Configuration</Typography.Title>

            <Form.Item
                label={
                    <Space align="center">
                        <span>System Prompt</span>
                        <Tooltip title="Optional: Provide instructions that guide the model's behavior.">
                            <InfoCircleOutlined style={{ fontSize: 13 }} />
                        </Tooltip>
                    </Space>
                }
                name={trainingProjectFormFields.systemPrompt}
                initialValue={store.editableTrainingProject ? store.editableTrainingProject.systemPrompt : undefined}
            >
                <Input.TextArea rows={4} placeholder="Optionally provide a system prompt..." allowClear />
            </Form.Item>

            <Form.Item
                label={
                    <Space align="center">
                        <span>Reference Model</span>
                        <Tooltip title="Choose the reference model">
                            <InfoCircleOutlined />
                        </Tooltip>
                    </Space>
                }
                name={trainingProjectFormFields.referenceModelId}
                initialValue={
                    store.editableTrainingProject ? store.editableTrainingProject.referenceModelId : undefined
                }
                rules={[{ required: true, message: 'Please select a reference LM manifest.' }]}
            >
                <Select
                    placeholder="Select a model manifest"
                    showSearch
                    allowClear
                    options={store.mlModelOptions}
                    filterOption={(input, option) =>
                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                    }
                />
            </Form.Item>

            <Form.Item
                label={
                    <Space align="center">
                        <span>Teacher Model</span>
                        <Tooltip title="Optional: Pick a teacher model.">
                            <InfoCircleOutlined />
                        </Tooltip>
                    </Space>
                }
                name={trainingProjectFormFields.teacherModelId}
                initialValue={store.editableTrainingProject ? store.editableTrainingProject.teacherModelId : undefined}
            >
                <Select
                    placeholder="Select a teacher model (optional)"
                    showSearch
                    allowClear
                    options={store.mlModelOptions}
                    filterOption={(input, option) =>
                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                    }
                />
            </Form.Item>

            <Form.Item
                label={
                    <Space align="center">
                        <span>Judge Model</span>
                        <Tooltip title="Optional: Pick a model used to judge/evaluate outputs.">
                            <InfoCircleOutlined />
                        </Tooltip>
                    </Space>
                }
                name={trainingProjectFormFields.judgeModelId}
                initialValue={store.editableTrainingProject ? store.editableTrainingProject.judgeModelId : undefined}
            >
                <Select
                    placeholder="Select a judge model (optional)"
                    showSearch
                    allowClear
                    options={store.mlModelOptions}
                    filterOption={(input, option) =>
                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                    }
                />
            </Form.Item>
        </>
    );
};

export default observer(TrainingProjectModelsSettings);
